import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Colors } from '../../../theme/colors';
import { TextFieldVariantProps } from './text-field.component';

export const useTextFieldStyles = makeStyles<Theme, TextFieldVariantProps>((theme) => ({
  textFieldLabel: {
    overflow: 'hidden !important',
    textOverflow: 'ellipsis !important',
    color: (props) =>
      props.variant === 'floating' ? Colors.midLightGray : props.variant === 'primarySolid' ? '#000000' : '#FFFFFF',
    fontSize: (props) => (props.variant === 'floating' ? '14px' : '13px'),
    fontWeight: (props) => (props.variant === 'floating' ? 400 : 500),
    marginTop: (props) => (props.variant === 'floating' || props.condensed ? '0px' : '-5px'),
    '&.MuiInputLabel-shrink': {
      marginTop: '0px',
      transform: (props) => (props.variant !== 'floating' ? `translate(14px, -2px) scale(0.75)` : '')
    },
    '&.Mui-focused': {
      display: 'none'
    }
  },
  textField: {
    height: (props) => (props.variant === 'floating' ? '' : '40px'),
    borderRadius: (props) => (props.variant === 'floating' ? '0px' : '4px'),
    background: (props) =>
      props.variant === 'floating' ? 'none' : props.variant === 'primarySolid' ? '#FFFFFF' : '#FFFFFF1F',
    color: (props) =>
      props.variant === 'floating' ? Colors.darkGray : props.variant === 'primarySolid' ? '#000000' : '#FFFFFF',
    fontSize: (props) => (props.variant === 'floating' ? '14px' : '13px'),
    fontWeight: (props) => (props.variant === 'floating' ? 400 : 500)
  },
  textFieldWidth: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: (props) => props.desktopWidth || '12em'
    }
  },
  textFieldRoot: {
    height: (props) => (props.variant === 'floating' ? '40px' : '')
  },
  solidTextFieldHover: {
    '& .MuiOutlinedInput-root:hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
      borderColor: (props) => (props.variant === 'primarySolid' ? undefined : 'white')
    }
  },
  solidTextFieldInUse: {
    '& .MuiOutlinedInput-root:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
      borderColor: (props) => (props.variant === 'primarySolid' ? undefined : 'white')
    }
  },
  floatingTextFieldHover: {
    '& > .MuiInput-underline:hover:not(.Mui-disabled)::before': {
      borderColor: Colors.collectedGreen
    }
  },
  dropdownIcon: {
    color: 'white'
  }
}));
